(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('environmentUtility', environmentUtility);

	function environmentUtility($location) {
		var subdomains = {
			'local': 'local',
			'internal': 'internal'
		};

		function getEnvironment() {
			var host = $location.host();
			var index = host.indexOf('.');
			return (index !== -1 && subdomains[host.substr(0, index)]) || 'production';
		}

		return {
			getEnvironment: getEnvironment
		};
	}
	environmentUtility.$inject = ['$location'];
})();
